// extracted by mini-css-extract-plugin
export default {"computerIcon":"G_hl1l"};